import { datadogRum } from '@datadog/browser-rum-slim';

export type ErrorContext = Record<string, unknown>;

export class ErrorWithContext extends Error {
  readonly context: ErrorContext;

  constructor(message: string, context: ErrorContext) {
    super(message);
    this.name = 'ErrorWithContext';
    this.context = context;
  }
}

export class ExpectedError extends Error {
  override name = 'ExpectedError';
}

export const reportError = (error: unknown, additionalContext: ErrorContext = {}): void => {
  const baseContext = error instanceof ErrorWithContext ? error.context : {};
  datadogRum.addError(error, { ...additionalContext, ...baseContext });
};
